import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
}
const initialState: AuthState = {
  accessToken: null,
  refreshToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTokens: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      localStorage.setItem("accessToken", action.payload?.accessToken);
      localStorage.setItem("refreshToken", action.payload?.refreshToken);
    },
    loadTokens: (state, action: PayloadAction<AuthState>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    clearTokens: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      state.accessToken = null;
    },
  },
});
export const { setTokens, clearTokens, loadTokens } = authSlice.actions;
export default authSlice.reducer;
